// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy                 from './components/CookiesPolicy';
import phoneLink   		             from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/js/dist/collapse';


connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();


cookiesPolicy({
	imgSrc: '/img/cookies/bernard.png',
	template: data => `
      <section class="cookies-policy ${ data.disableRwdImg } ${ data.enableModal }" data-fragment="cp.pane">
        <div class="cookies-policy__container">
          ${ data.enableCloseButton ? `<button class="cookies-policy__btn-close" data-fragment="cp.closeButton"><span class="cookies-policy__btn-close-text">${ data.closeBtn }</span></button>` : '' }
          ${ data.enableImg ? `<header class="cookies-policy__header"><img class="cookies-policy__img" src="${ data.imgSrc }" alt="" /></header>` : '' }
          <div class="cookies-policy__main">
            <h2 class="cookies-policy__heading">${ data.heading }</h2>
            <p class="cookies-policy__perex">${ data.perex }</p>
            <div class="cookies-policy__buttons">
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.acceptAllBtn">${ data.acceptAllBtn }</button>
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.rejectButton">${ data.rejectBtn }</button>
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.openSettingsButton">${ data.settingsBtn }</button>
            </div>
          </div>
        </div>
      </section>`,
	messages: {
		si: {
			heading: 'Keeping your site working well',
			perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/si/informacije-o-spletu">see here</a>.',
			closeBtn: 'Close',
			settingsBtn: 'Cookies settings',
			rejectBtn: 'Reject',
			acceptAllBtn: 'Enable all cookies',
		},
		se: {
			heading: 'Keeping your site working well',
			perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/se/information-om-webben">see here</a>.',
			closeBtn: 'Close',
			settingsBtn: 'Cookies settings',
			rejectBtn: 'Reject',
			acceptAllBtn: 'Enable all cookies',
		},
		ru: {
			perex: 'Этот сайт использует файлы cookie для обеспечения функций социальных сетей и анализа трафика. Нажав на кнопку «Разрешить все файлы cookie», Вы соглашаетесь на хранение и использование файлов cookie. Подробную информацию о файлах cookie <a class="cookies-policy__link" href="/ru/information-about-the-web">можно найти здесь</a>.',
		},
	},
	settingsMessages: {
		si: {
			heading: 'Cookies settings',
			perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/si/informacije-o-spletu">Cookie information</a>',
			acceptAllBtn: 'Enable all cookies',
			acceptSelectedBtn: 'Enable selected cookies',
			checkboxStateOff: 'OFF',
			checkboxStateOn: 'ON',
			closeBtn: 'Close',
			technicalTitle: 'Technical cookies',
			technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
			technicalState: 'Always ON',
			analyticsMarketingTitle: 'Analytical and marketing cookies',
			analyticsTitle: 'Analytical cookies',
			analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
			marketingTitle: 'Marketing cookies',
			marketingPerex: 'Thanks to these cookies, we or third parties can customize the offer of our services after your visit. This offer can then be displayed outside of our website.',
		},
		se: {
			heading: 'Cookies settings',
			perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/se/information-om-webben">Cookie information</a>',
			acceptAllBtn: 'Enable all cookies',
			acceptSelectedBtn: 'Enable selected cookies',
			checkboxStateOff: 'OFF',
			checkboxStateOn: 'ON',
			closeBtn: 'Close',
			technicalTitle: 'Technical cookies',
			technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
			technicalState: 'Always ON',
			analyticsMarketingTitle: 'Analytical and marketing cookies',
			analyticsTitle: 'Analytical cookies',
			analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
			marketingTitle: 'Marketing cookies',
			marketingPerex: 'Thanks to these cookies, we or third parties can customize the offer of our services after your visit. This offer can then be displayed outside of our website.',
		},
		ru: {
			perex: 'Здесь вы можете указать, какие файлы cookie мы будем обрабатывать. Более подробную информацию см. на странице <a class="cookies-settings__link" href="/ru/information-about-the-web">использованием cookies</a>',
		},
	},
});




// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js